import React, { useEffect, useState } from 'react';

import { Redirect } from 'react-router-dom';

import Spinner from 'components/Spinner';
import useQueryParams from 'hooks/useQueryParams';
import { useAppDispatch } from 'hooks/useStore';
import { User } from 'models/User';
import { safeLazy } from 'routes/helpers';
import { userSignInSuccess } from 'store/modules/auth';
import { apiGet } from 'utils/request';

import { TwoFaType } from './components/helpers';
import SignIn from './components/SignIn';

const ForceResetPassword = safeLazy(() => import('./components/ForceResetPassword'));
const TwoFaApp = safeLazy(() => import('./components/TwoFaApp'));
const AskEnableBiometrics = safeLazy(() => import('./components/AskEnableBiometrics'));
const TwoFaRequired = safeLazy(() => import('./components/TwoFaRequired'));

const SignInPage = () => {
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showEnableBiometrics, setShowEnableBiometrics] = useState(false);
  const [showTwoFaRequired, setShowTwoFaRequired] = useState(false);
  const [show2FaData, setShow2FaData] = useState<TwoFaType | null>(null);
  const [user, setUser] = useState<User | null>(null);

  if (showTwoFaRequired) {
    return <TwoFaRequired user={user!} />;
  }

  if (showEnableBiometrics) {
    return <AskEnableBiometrics />;
  }

  return showChangePassword ? (
    <ForceResetPassword user={user} setShowTwoFaRequired={setShowTwoFaRequired} />
  ) : show2FaData ? (
    <TwoFaApp
      twoFaData={show2FaData}
      setShowChangePassword={setShowChangePassword}
      setUser={setUser}
      setShowEnableBiometrics={setShowEnableBiometrics}
    />
  ) : (
    <SignIn
      setShowTwoFaRequired={setShowTwoFaRequired}
      setShowChangePassword={setShowChangePassword}
      setUser={setUser}
      setShowTwoFa={setShow2FaData}
      setShowEnableBiometrics={setShowEnableBiometrics}
    />
  );
};

const SignInPageWrapper = () => {
  const [samlError, setSamlError] = useState(false);
  const dispatch = useAppDispatch();

  const queryParams = useQueryParams();
  const token = queryParams.get('token') || '';
  const samlLogin = async () => {
    try {
      sessionStorage.setItem('auth', JSON.stringify({ token: token, user: {} }));

      const userData = await apiGet('/users/me', { action: 'getUser' });

      sessionStorage.setItem('auth', JSON.stringify({ token: token, user: userData }));

      dispatch(userSignInSuccess(userData));
    } catch (e) {
      console.log(e);
      setSamlError(true);
    }
  };

  useEffect(() => {
    if (!token) return;
    samlLogin();
  }, []);

  if (token && samlError) {
    return <Redirect to="/signin/error" />;
  }

  if (token) {
    return <Spinner main />;
  }

  return <SignInPage />;
};

export default SignInPageWrapper;
